import "./DataNotFound.css";

function DataNotFound () {



    return (
        <div className="container-fluid">
            <p>Data Not Found.</p>
        </div>
    )
}


export default DataNotFound;